import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { LiteratureDataUploadComponent } from './literature-data-upload/literature-data-upload.component';
import { BiologicalDataUploadComponent } from './biological-data-upload/biological-data-upload.component'
import { SensorDataUploadComponent } from './sensor-data-upload/sensor-data-upload.component';
import { PhysicochemicalDataComponent } from './physicochemical-data/physicochemical-data.component';
const routes: Routes = [
  { path: 'sensor', component: SensorDataUploadComponent, canActivate: [AuthGuard] },
  { path: 'biological', component: BiologicalDataUploadComponent, canActivate: [AuthGuard] },
  { path: 'literature', component: LiteratureDataUploadComponent, canActivate: [AuthGuard] },
  { path: 'physicochemical', component: PhysicochemicalDataComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DataUploadRoutingModule {}